/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfaceFaqItem } from './SurfaceFaqItem';
import {
    SurfaceFaqItemFromJSON,
    SurfaceFaqItemFromJSONTyped,
    SurfaceFaqItemToJSON,
    SurfaceFaqItemToJSONTyped,
} from './SurfaceFaqItem';
import type { SurfaceRulesSection } from './SurfaceRulesSection';
import {
    SurfaceRulesSectionFromJSON,
    SurfaceRulesSectionFromJSONTyped,
    SurfaceRulesSectionToJSON,
    SurfaceRulesSectionToJSONTyped,
} from './SurfaceRulesSection';

/**
 * 
 * @export
 * @interface SurfaceFaqConfig
 */
export interface SurfaceFaqConfig {
    /**
     * 
     * @type {Array<SurfaceFaqItem>}
     * @memberof SurfaceFaqConfig
     */
    items?: Array<SurfaceFaqItem>;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceFaqConfig
     */
    allowMultipleOpen?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceFaqConfig
     */
    searchable?: boolean;
    /**
     * One line under the section title — "Everything you need to know about X". Sets up the legal summary and the questions beneath it.
     * @type {string}
     * @memberof SurfaceFaqConfig
     */
    intro?: string;
    /**
     * The official rules, in order. Present, the section renders the rules affordance; absent, it is FAQs alone.
     * @type {Array<SurfaceRulesSection>}
     * @memberof SurfaceFaqConfig
     */
    rulesSections?: Array<SurfaceRulesSection>;
    /**
     * The affordance's label. Defaults to "Read Full Official Rules".
     * @type {string}
     * @memberof SurfaceFaqConfig
     */
    rulesLabel?: string;
    /**
     * The modal's heading. Defaults to "Official Rules".
     * @type {string}
     * @memberof SurfaceFaqConfig
     */
    rulesTitle?: string;
    /**
     * Heading over the summary paragraphs. Defaults to "Official Rules".
     * @type {string}
     * @memberof SurfaceFaqConfig
     */
    termsHeading?: string;
}

/**
 * Check if a given object implements the SurfaceFaqConfig interface.
 */
export function instanceOfSurfaceFaqConfig(value: object): value is SurfaceFaqConfig {
    return true;
}

export function SurfaceFaqConfigFromJSON(json: any): SurfaceFaqConfig {
    return SurfaceFaqConfigFromJSONTyped(json, false);
}

export function SurfaceFaqConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceFaqConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(SurfaceFaqItemFromJSON)),
        'allowMultipleOpen': json['allowMultipleOpen'] == null ? undefined : json['allowMultipleOpen'],
        'searchable': json['searchable'] == null ? undefined : json['searchable'],
        'intro': json['intro'] == null ? undefined : json['intro'],
        'rulesSections': json['rulesSections'] == null ? undefined : ((json['rulesSections'] as Array<any>).map(SurfaceRulesSectionFromJSON)),
        'rulesLabel': json['rulesLabel'] == null ? undefined : json['rulesLabel'],
        'rulesTitle': json['rulesTitle'] == null ? undefined : json['rulesTitle'],
        'termsHeading': json['termsHeading'] == null ? undefined : json['termsHeading'],
    };
}

export function SurfaceFaqConfigToJSON(json: any): SurfaceFaqConfig {
    return SurfaceFaqConfigToJSONTyped(json, false);
}

export function SurfaceFaqConfigToJSONTyped(value?: SurfaceFaqConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(SurfaceFaqItemToJSON)),
        'allowMultipleOpen': value['allowMultipleOpen'],
        'searchable': value['searchable'],
        'intro': value['intro'],
        'rulesSections': value['rulesSections'] == null ? undefined : ((value['rulesSections'] as Array<any>).map(SurfaceRulesSectionToJSON)),
        'rulesLabel': value['rulesLabel'],
        'rulesTitle': value['rulesTitle'],
        'termsHeading': value['termsHeading'],
    };
}

